<template>
  <component
    :is="tag"
    :id="groupId"
    :class="[ns.b('group'), ns.is('vertical', vertical)]"
    role="group"
    data-test-name="checkbox-group"
    data-test-variant=""
    data-test-state=""
  >
    <slot />
  </component>
</template>

<script lang="ts" setup>
import { computed, nextTick, provide, toRefs } from 'vue'
import { pick } from 'lodash-unified'
import { UPDATE_MODEL_EVENT } from '@bigin/constants'
import { useFormItem, useFormItemInputId, useNamespace } from '@bigin/hooks'
import { checkboxGroupContextKey } from '@bigin/tokens'
import { checkboxGroupEmits, checkboxGroupProps } from './checkbox-group'

import type { CheckboxValueType } from './checkbox'

defineOptions({
  name: 'BCheckboxGroup',
})

const props = defineProps(checkboxGroupProps)
const emit = defineEmits(checkboxGroupEmits)
const ns = useNamespace('checkbox')

const { formItem } = useFormItem()
const { inputId: groupId } = useFormItemInputId(props, {
  formItemContext: formItem,
})

const changeEvent = async (value: CheckboxValueType[]) => {
  emit(UPDATE_MODEL_EVENT, value)
  await nextTick()
  emit('change', value)
}

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(val: CheckboxValueType[]) {
    changeEvent(val)
  },
})

provide(checkboxGroupContextKey, {
  ...pick(toRefs(props), [
    'size',
    'min',
    'max',
    'disabled',
    'large',
    'small',
    'vertical',
  ]),
  modelValue,
  changeEvent,
})
</script>
